/* eslint-disable no-useless-concat */
import { LANGUAGE_CODES } from "../constants/config-constants";
import MuleFetchUtil from "../common/mule-fetch-util";
import { format } from 'date-fns';
import { refreshTokenAPIService } from "../services/SessionService";
import { detectIncognito } from "detectincognitojs";
import { v4 as uuidv4 } from 'uuid';

export const getCountryCode = () => {
  // return  env.COUNTRY_CODE;
  return "ID";
};

export const getLanguageCode = () => {
  // const countryCode = getCountryCode();
  let languageCode;
  // switch (countryCode) {
  //   case MARKETS.VIETNAM: {
  //     languageCode = LANGUAGE_CODES.VN;
  //     break;
  //   }
  //   default: {
  //     languageCode = LANGUAGE_CODES.EN;
  //   }
  // }
  languageCode = LANGUAGE_CODES.EN;

  return languageCode;
};

export const setCookie = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Strict; Secure`;
};
export const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  let result = null;
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split("=");
    const cookieName = cookie[0];
    const cookieValue = cookie[1];
    if (cookieName === name) {
      result = cookieValue;
      break;
    }
  }
  return result;
};
export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
};

let isSessionExpiryHandled = false;

const clearClientSession = () => {
  // Clear all localStorage
  localStorage.clear();

  // Clear all sessionStorage
  sessionStorage.clear();

  // Delete all cookies
  deleteCookie("idToken");
  deleteCookie("refreshToken");
  deleteCookie("countryCode");

  // Clear document.cookie as fallback
  const cookies = document.cookie.split(";");
  cookies.forEach(cookie => {
    const cookieName = cookie.split("=")[0].trim();
    if (cookieName) {
      deleteCookie(cookieName);
    }
  });
};

export const handleSessionExpiry = () => {
  if (isSessionExpiryHandled) return;
  isSessionExpiryHandled = true;
  const authRoutes = ["/", "/login", "/signup", "/forgotpassword"];
  const currentPath = window.location.pathname;
  const isAuthRoute = authRoutes.includes(currentPath);

  clearClientSession();
  
  if (!isAuthRoute) {
    alert("Your session is expired please login again.");
  }

  if (currentPath !== "/login") {
    window.location.assign("/login");
  }
};

export const LogoutInvalidToken = () => {
  handleSessionExpiry();
};

export const handleSilentSessionReset = () => {
  if (isSessionExpiryHandled) return;
  isSessionExpiryHandled = true;
  const currentPath = window.location.pathname;

  clearClientSession();

  if (currentPath !== "/login") {
    window.location.assign("/login");
  }
};

let isRefreshing = false;

export const RefreshTokenReload = async (refreshToken) => {
  if (isRefreshing) return;
  isRefreshing = true;

  let obj = {
    grant_type: "refresh_token",
    refresh_token: refreshToken,
  };
  const countryCode = localStorage.getItem("countryCode");
  const oldToken = getCookie("idToken");
  let result = MuleFetchUtil.post(
    "fb/accounts/refreshtoken",
    { customerToken: oldToken, countryCode: countryCode },
    obj,
    "signInWithPassword"
  );
  result.then(async (response) => {
    if (response.statusCode === 200 && response["response-data"].id_token) {
      const newToken = response["response-data"].id_token;
      setCookie("idToken", newToken);
      await refreshTokenAPIService(countryCode, oldToken, newToken);
      window.location.reload();
    } else {
      isRefreshing = false;
      handleSessionExpiry();
    }
    isRefreshing = false;
  }).catch((err) => {
    console.error("Error refreshing token:", err);
    isRefreshing = false;
    handleSessionExpiry();
  });
};

export const sortCountryArray = (countries) => {
  const dummy = ["id","idic","vn", "ph", "th","pk","bd"];
  const sortedCountryArray = countries.sort((a, b) => {
    return dummy.indexOf(a) - dummy.indexOf(b);
  });
  return sortedCountryArray;
};

export const dateTimeFormatter = (props) => {
  if (props.value) {
    try {
      let date = format(new Date(props.value), 'dd-MMM-yy | HH:mm');
      return date;
    } catch (e) {
      return '--';
    }
  } else {
    return '--';
  }
};

export const getUserAgent = async () => {
  let userAgent = navigator.userAgent.toLowerCase();
  let uuID = localStorage.getItem("UUID") || uuidv4();  
  let deviceId = userAgent + uuID;
  const isIncognito = await detectIncognito();
  if (isIncognito.isPrivate) {
    deviceId += " incognito";
  }
  return deviceId;
}

